// removed by extract-text-webpack-plugin
module.exports = {"root":"styles__root___jyBTn"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/ConfigurationSubHeader/styles.scss
// module id = 1029
// module chunks = 0